import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=b086893a&scoped=true&"
import script from "./Credit.vue?vue&type=script&lang=js&"
export * from "./Credit.vue?vue&type=script&lang=js&"
import style0 from "./Credit.vue?vue&type=style&index=0&id=b086893a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b086893a",
  null
  
)

export default component.exports